/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.ProfessorRpc
 */

export const getProfessorRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.ProfessorRpc',
  rpcName: 'getProfessor',
  auth: 'app',
  fingerprint: 'LerK4IcC9ulw03KFLIzdy4U1lhEpE_sB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProfessorsRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.ProfessorRpc',
  rpcName: 'getProfessors',
  auth: 'app',
  fingerprint: 'zbBMLT5hmdOemAmXjXfoU4U1lhEpE_sB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};